import { render, staticRenderFns } from "./EnrollTabCardPayment.vue?vue&type=template&id=d480653a&scoped=true&"
import script from "./EnrollTabCardPayment.vue?vue&type=script&lang=ts&"
export * from "./EnrollTabCardPayment.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollTabCardPayment.vue?vue&type=style&index=0&id=d480653a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d480653a",
  null
  
)

export default component.exports